const createEnvironmentFlags = (development = false, staging = false, production = false) => ({
  development,
  staging,
  production,
});

const flags = {
  uploadcareWidget: createEnvironmentFlags(true, true, true), // INV-1603
  modularizedRegistryTile: createEnvironmentFlags(true, true, true), // remove old components
  cartViewedEvent: createEnvironmentFlags(true, true, true),
  fastFacets: createEnvironmentFlags(true, true, false),
  seatingChartView2: createEnvironmentFlags(false, false, false), // - this is on hold
  persistentCart: createEnvironmentFlags(true, true, true),
  fontRenderFix: createEnvironmentFlags(true, true, false), // INVITES-1054
  pdpModalModule: createEnvironmentFlags(true, true, true),
  publicWebNavCartModal: createEnvironmentFlags(true, true, true),
  newPlpCardTile: createEnvironmentFlags(false, false, false), // INV-501
  singleSampleNoFoil: createEnvironmentFlags(true, true, true), // INV-784
  confirmExitModalFlag: createEnvironmentFlags(true, true, false), // WEDDINGS-1785
  invitesTipModalsWithLinks: createEnvironmentFlags(true, true, true), // INV-1141 & INV-1145
  invitesReviewTipsAllModals: createEnvironmentFlags(true, true, true), // INV-1231
  invitesComparisonModuleMvp: createEnvironmentFlags(true, true, true), // INV-1107
  invitesRelatedSameCardType: createEnvironmentFlags(true, true, true), // INV-1209
  invitesLetterpressFilter: createEnvironmentFlags(true, true, true), // INV 1154
  invitesLetterpressSingleSample: createEnvironmentFlags(true, true, true), // INV-1164
  invitesSingleSampleModal: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSingleSampleModalPDP: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSinglesampleSaveToDraftsOnExit: createEnvironmentFlags(false, false, false), // INV-1265
  invitesSingleSampleLimitScreen: createEnvironmentFlags(true, true, true), // INV-1265
  invitesSingleSampleCustomizeStep: createEnvironmentFlags(true, true, true), // INV-1597
  invitesMultiSampleFlow: createEnvironmentFlags(true, true, true), // INV-1541
  invitesMultiSampleTutorialModal: createEnvironmentFlags(true, true, true), // INV-1541
  invitesSingleSampleFoilDropdown: createEnvironmentFlags(true, true, true), // INV-1762
  addBannerAdToPLP: createEnvironmentFlags(true, true, true), // INV-1139
  isRequestMissingInfoModal: createEnvironmentFlags(true, true, true), // WEDDINGS-1870
  invitesGuestFontOverrides: createEnvironmentFlags(true, true, true), // INV-1066
  usePreCheckoutSuggestionsModal: createEnvironmentFlags(true, true, true), // INV-1149
  seatingChartLanding: createEnvironmentFlags(true, true, true), // WED-1927
  weddingShopModalAb: createEnvironmentFlags(true, true, true), // INV-1210
  enableMostWantedTest: createEnvironmentFlags(true, true, true), // REGISTRY-4238
  skinnyBannerRedesign: createEnvironmentFlags(true, true, true), // INV-1347
  rsvpImageUploader: createEnvironmentFlags(true, true, true),
  plpElopementFilter: createEnvironmentFlags(true, true, true), // INV-1405
  plpNoPhotoFilter: createEnvironmentFlags(true, true, true), // INV-1246
  expeditedShippingModal: createEnvironmentFlags(false, false, false), // INV-1439
  collapsibleNav: createEnvironmentFlags(true, true, true), // REGISTRY-4436
  magnetFoilSingleSample: createEnvironmentFlags(true, true, true), // INV-1502
  newSizesHC: createEnvironmentFlags(true, true, true), // INV-1532
  stampFoilHC: createEnvironmentFlags(true, true, true), // INV-1675
  newSizesTY: createEnvironmentFlags(true, true, true), // INV-1532
  envelopeVariationDefault: createEnvironmentFlags(true, true, true), // INV-1533
  colouredEnvelope: createEnvironmentFlags(true, true, true), // INV-1573
  fetchListedCardDataOnly: createEnvironmentFlags(true, true, true),
  freeCustomFoilEvent: createEnvironmentFlags(false, false, false), // INV-1562 // INV-1789
  hideAds: createEnvironmentFlags(false, false, false), // INV-1524
  singleSampleEnvelopes: createEnvironmentFlags(true, true, false), // INV-1588
  bleedRedesign: createEnvironmentFlags(true, true, true), // INV-1673
  increaseUploadLimit: createEnvironmentFlags(true, true, true), // INV-2188
  albumsAllowLowResUploads: createEnvironmentFlags(true, true, true), // INV-1849
  cardsAddTextWidth: createEnvironmentFlags(true, true, true), // COMMERCE-135
  invitesZendeskChat: createEnvironmentFlags(true, true, true), // COMMERCE-11
  albumsMultiUse: createEnvironmentFlags(true, true, true), // COMMERCE-137
  albumsPromoBadge: createEnvironmentFlags(true, true, true), // COMMERCE-215
  albumsWizardVideo: createEnvironmentFlags(true, true, true), // COMMERCE-216
  albumsDeletePhoto: createEnvironmentFlags(true, true, true), // COMMERCE-15
  albumsRedesignedOrganize: createEnvironmentFlags(true, true, true), // COMMERCE-384
  albumsRegistryPLPCTA: createEnvironmentFlags(true, true, true), // COMMERCE-189
  albumsRegistryPDPCTA: createEnvironmentFlags(true, true, true), // COMMERCE-189
  albumsSimulatePrintQuality: createEnvironmentFlags(true, true, true), // COMMERCE-254
  albumsOrderAgain: createEnvironmentFlags(true, true, true), // COMMERCE-379
  albumOptionsMenu: createEnvironmentFlags(true, true, true), // COMMERCE-273
  albumsCoverColorPicker: createEnvironmentFlags(true, true, true), // COMMERCE-273
  albumsFTERedesign: createEnvironmentFlags(true, true, true), // COMMERCE-503
  albumsChecklistMenu: createEnvironmentFlags(true, true, true), // COMMERCE-504
  albumsMoreUploadSources: createEnvironmentFlags(true, true, false), // COMMERCE-433
  albumsGenerateWithoutPayload: createEnvironmentFlags(true, true, true), // COMMERCE-621
  registryScraperBanner: createEnvironmentFlags(true, true, true), // COMMERCE-286
  albumsPDPHover: createEnvironmentFlags(true, true, true), // COMMERCE-162
  uniqueSTD: createEnvironmentFlags(true, true, true), // COMMERCE-406
  envelopeLiner: createEnvironmentFlags(true, true, true), // COMMERCE-342
  envelopeLinerRSVP: createEnvironmentFlags(false, false, false), // COMMERCE-342 second iteration
  seoColorSeasonFilters: createEnvironmentFlags(true, true, true), // COMMERCE-461
  albumsPricingBreakdown: createEnvironmentFlags(true, true, true), // COMMERCE-482
  albumsPricingMatrix: createEnvironmentFlags(true, true, true), // COMMERCE-480
  datadog: createEnvironmentFlags(false, true, false), // Toggle datadog monitoring
  cardsOutOfStock: createEnvironmentFlags(true, true, true), // COMMERCE-588
  cardsSortBy: createEnvironmentFlags(true, true, true), // COMMERCE-652
  invitesPlaceCards: createEnvironmentFlags(true, true, true), // COMMERCE-563
  invitesPlaceCardsImport: createEnvironmentFlags(true, true, true), // COMMERCE-713
  matchingPaperSuite: createEnvironmentFlags(true, true, true), // CE-1284
  cardsFavoriting: createEnvironmentFlags(true, true, true), // COMMERCE-639
  cardsMultiSampleTile: createEnvironmentFlags(true, true, true), // COMMERCE-839
  singlePagePaperOnboard: createEnvironmentFlags(true, true, false), // CE-1397
};

type Environments = 'development' | 'staging' | 'production';
const getEnvironment = (): Environments => {
  const zolaEnv: string | undefined =
    (typeof window !== 'undefined' && window.zola && window.zola.env) || process.env.NODE_ENV;
  switch (zolaEnv) {
    case 'development':
    case 'dev':
      return 'development';
    case 'staging':
    case 'stage':
      return 'staging';
    case 'production':
    case 'prod':
      return 'production';
    default:
      return 'production';
  }
};

export type FeatureFlag = keyof typeof flags;

const get = (flag: FeatureFlag): boolean => {
  if (flags[flag]) {
    return Boolean(flags[flag][getEnvironment()]);
  }
  return false;
};

export default {
  get,
  getEnvironment,
};
